import { Form, Formik } from "formik";
import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { postApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Input from "../../components/common/inputs/Input";
import Select from "../../components/common/inputs/Select";
import TextArea from "../../components/common/inputs/TextArea";
import { motion } from "framer-motion";
import UserModal from "../../components/common/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import { context } from "../../context/context";
import { ticketValidate } from "../../components/common/validations/ticketValidate";

function Ticket() {
  const navigate = useNavigate();

  const { utils } = useContext(context);

  const userModalRef = useRef();

  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const addTickets = async (values, { resetForm }) => {
    if (user) {
      const path = `tickets`;
      const body = { ...values, user: user?._id };
      try {
        await postApi({ path, body });
        successMessage("پیام شما با موفقیت ثبت شد.");
        resetForm();
        setUser(null);
        setUserInfo("");
        navigate("/ticket-list");
      } catch (error) {
        console.log(error);
        errorMessage(error?.response?.data?.errors[0]?.message);
      }
    } else {
      warningMessage("لطفا یک کاربر انتخاب کنید.");
    }
  };

  const handleUser = (data) => {
    setUser(data);
    setUserInfo(data?.name || data?.mobile);
    successMessage(`کاربر ${data?.name || data?.mobile} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser(null);
    setUserInfo("");
  };

  return (
    <>
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <h3 className="text-gray-800 dark:text-white text-lg">پیام جدید</h3>
        <div className="w-11/12 mx-auto  mt-6">
          <Formik
            initialValues={{
              title: "",
              department: "",
              message: "",
            }}
            validationSchema={ticketValidate}
            onSubmit={addTickets}
          >
            {() => (
              <Form>
                <div className="mt-6">
                  <div className="grid gap-6 md:grid-cols-3">
                    <Input
                      name="title"
                      placeholder="عنوان پیام"
                      label="عنوان پیام"
                      type="text"
                    />
                    <Select
                      name="department"
                      placeholder=" بخش مربوطه"
                      label=" بخش مربوطه"
                    >
                      <option value={""}>انتخاب بخش</option>
                      {utils?.TICKET_DEPARTMENTS_VALUES?.length
                        ? utils?.TICKET_DEPARTMENTS_VALUES.map((item) => {
                            return (
                              <option value={item?.value}>{item?.name}</option>
                            );
                          })
                        : null}
                    </Select>

                    <div className="relative">
                      <span
                        onClick={() => userModalRef?.current?.showModal()}
                        className="absolute w-full h-full"
                      ></span>
                      {user ? (
                        <PiXFill
                          className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
                          onClick={deleteUser}
                        />
                      ) : null}
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        انتخاب کاربر
                      </label>
                      <input
                        value={userInfo}
                        onChange={(e) => setUserInfo(e.target.value)}
                        disabled
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                  </div>
                  <div className="grid gap-4 mt-4">
                    <TextArea
                      inputClass="min-h-32"
                      name="message"
                      placeholder="پیام"
                      label="پیام"
                      type="text"
                    />
                  </div>
                  <button
                    type="submit"
                    class="mt-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    ارسال پیام
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </motion.div>
    </>
  );
}

export default Ticket;
